const Area = () => import('@/views/partner/Area')
const Level = () => import('@/views/partner/Level')
const Partner = () => import('@/views/partner/Partner')
const PartnerMerchant = () => import('@/views/partner/PartnerMerchant')
const InformationSubmitQrCode = () => import('@/views/partner/InformationSubmitQrCode')
const manualWithdrawRecord = () => import('@/views/partner/ManualWithdrawRecord')
export const partner = [
  {
    path: '/partner/area',
    name: '区域管理',
    component: Area,
    meta: {
      requireAuth: true,
      title: '区域管理'
    }
  },
  {
    path: '/partner/level',
    name: '等级管理',
    component: Level,
    meta: {
      requireAuth: true,
      title: '等级管理'
    }
  },
  {
    path: '/partner/list',
    name: '伙伴列表',
    component: Partner,
    meta: {
      requireAuth: true,
      title: '伙伴列表'
    }
  },
  {
    path: '/partner/merchant',
    name: '商户列表',
    component: PartnerMerchant,
    meta: {
      requireAuth: true,
      title: '商户列表'
    }
  },
  {
    path: '/partner/merchant/information/submit/qrCode',
    name: '进件码',
    component: InformationSubmitQrCode,
    meta: {
      requireAuth: true,
      title: '进件码'
    }
  },
  {
    path: '/partner/manual/withdraw/record',
    name: '手动提现记录',
    component: manualWithdrawRecord,
    meta: {
      requireAuth: true,
      title: '进件码'
    }
  },
];



// WEBPACK FOOTER //
// ./src/router/partner.route.js